import React from 'react';
import { CTAButton } from './CTAButton';
const sequence = ['Observe', 'Interpret', 'Decide', 'Refine', 'Validate'];
export function ShiftSection() {
  return <section className="w-full bg-navy-950 py-14 sm:py-20" data-id="element-317" data-mp="c5pux9vlurfs">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-318" data-mp="3uj5sohupk6jz">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-400" data-id="element-319" data-mp="2dsfts1h7fbs">
          The shift is simple
        </p>

        <h2 className="mt-4 text-center font-display text-[26px] font-bold leading-[1.15] text-cream-100 sm:text-4xl lg:text-[42px]" data-id="element-320" data-mp="q460gxhqebwc">
          The articulating paper is not the start.{' '}
          <em className="not-italic text-gold-400" data-id="element-321" data-mp="h26hhzn5oxqr">It’s the refinement.</em>
        </h2>

        <p className="mx-auto mt-5 max-w-xl text-center text-[15px] leading-relaxed text-cream-100/75 sm:text-lg" data-id="element-322" data-mp="m0zy40xqp4v5">
          Before reaching the articulating paper, you need a structured way to:
        </p>

        <ol className="mx-auto mt-8 grid w-full max-w-md gap-2.5" data-id="element-323" data-mp="36t1qmex64ev3">
          {sequence.map((step, index) => <li key={step} className="flex items-center gap-4 rounded-2xl border border-gold-500/25 bg-navy-800 px-4 py-3.5" data-id="element-324" data-mp="vgujk0rbol0u" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold-500 font-display text-base font-bold text-navy-900" data-id="element-325" data-mp="15es70m1cydse">
                {index + 1}
              </span>
              <span className="text-[16px] font-extrabold uppercase tracking-wide text-cream-100 sm:text-lg" data-id="element-326" data-mp="1eef2kr7eopdj">
                {step}
              </span>
            </li>)}
        </ol>

        <p className="mt-8 text-center font-display text-[20px] font-bold text-cream-100 sm:text-2xl" data-id="element-327" data-mp="1o59o1tctvkxx">
          That is <span className="text-gold-400" data-id="element-328" data-mp="1j6yfdly9rgha">Occlusion 360™</span>.
        </p>

        <div className="mx-auto mt-8 w-full max-w-md" data-id="element-329" data-mp="1x56hs9e2r9zu">
          <CTAButton label="I want the Occlusion 360™ system" subline="Instant access · One-time payment of $27 USD" data-id="element-330" data-mp="1x3lmghjxrn0x" />
        </div>
      </div>
    </section>;
}